export function getParameterByName( paramName: string ) : any {
	let url = window.location.href;
	let regex = new RegExp('[?&]' + paramName + '(=([^&#]*)|&|#|$)');
	let results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////

export function getCookie(name: string) : string {
    name = name + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.indexOf(name) == 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }

    return '';
}

export function setCookie( name: string, value: string, expireDays: number )  {
    var now = new Date();
    now.setTime(now.getTime() + (expireDays*24*60*60*1000));
    document.cookie= name + "=" + value + ";expires=" + now.toUTCString() + ";"
}

export function setCookieWithExpireTime ( key:string, value:string, days:number) : void {

    // irritating that we have to do this browser-cookies code instead of the brownies cookies library...
    // There seems to be no way to disable encoding of the stored value so the stored cookie
    // is useless to outside parties unless they know the cookie is encoded. autoencode: false
    // doesn't seem to fix this.

    // console.log( "SET COOKIE "+ key + " = " + value + " days="+days)

    // todo add cookies library and uncomment...

   // cookies.set( key, value, {expires:days} );
}


////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
//
//  Console
//

const gLogTitle : string = "GPP CMP";
const gDebugLevel : number = 0;

export function getCallerContext() {

	// let e  = new Error();
	// let stack  = e.stack;
	// let line  = stack.split("\n")[4];
	// let lineParts = line.split(":");
	// return lineParts[2]; 
}

export function doConsolePrint( ...args : [string] ) {
		queueMicrotask (console.log.bind (console, ...args));
}

export function doAmpLog( ampHead :string, msg:string, msgStyle:string ) {
		
// @ts-ignore
		let lineNumberText  :string = undefined; // "Line " + getCallerContext();
		
		let ampHeadStyle :string  = "background-color:#430F64;border:solid 1px #7E31AE;padding:2px 8px;border-radius:2px;font-weight:900;color:#ded;margin-right:6px;"
		let lineNumberStyle :string  = "background-color:#430F64;border:solid 1px #7E31AE;padding:2px 8px;border-radius:2px;color:#cdc;margin-right:10px;margin-top:-1px;font-size:80%;font-weight:500;"

		if ( msg ) {
// @ts-ignore
				doConsolePrint( "%c" + ampHead + "%c" + msg  , ampHeadStyle, msgStyle );
		}
		else
// @ts-ignore
			doConsolePrint( "%c" + ampHead, ampHeadStyle );
}

export function ampLogInfo( msg:string ) {
		doAmpLog( gLogTitle, msg, "font-weight:500;" ) 
}

export function ampLogDebug( level:number, msg:string ) {
		if ( gDebugLevel >= level) 
		doAmpLog( gLogTitle, msg, "font-weight:500;color:#888;" );
}

export function ampLogError( msg:string ) {
		let msgStyle = "width:100%;background-color:#7b2222;padding:2px 4px;border-radius:2px;font-weight:500;color:#EEF;margin-right:4px;";
		doAmpLog( gLogTitle, "Error: " + msg, msgStyle ) 
}

 export function ampLogWarning( msg:string ) {
		let msgStyle = "width:100%;background-color:#7a7222;padding:2px 4px;border-radius:2px;font-weight:500;color:#EEF;margin-right:4px;";
		doAmpLog( gLogTitle, "Warning: " + msg, msgStyle ) 
}


